module.exports = __webpack_public_path__ + "img/card-bg-03.7ad7af42.png";